import React from 'react';
import {
  FiShield,
  FiTrendingUp,
  FiUsers,
  FiCpu,
  FiClock
} from 'react-icons/fi';
import RmbIcon from '../RmbIcon';
import './CoreAdvantages.css';

const CoreAdvantages = () => {
  const advantages = [
    {
      icon: <FiShield />,
      title: '双甲级资质事务所',
      desc: '工程造价咨询甲级、招标代理甲级，国家高新技术企业，ISO9001质量体系认证'
    },
    {
      icon: <FiCpu />,
      title: 'AI+数智化核心能力',
      desc: 'AI智能审核引擎、BIM+造价一体化平台、全过程管控系统，审核效率提升85%，准确率98.6%'
    },
    {
      icon: <FiUsers />,
      title: '资深专家团队',
      desc: '38名注册造价工程师，12名高级工程师，15年以上行业经验核心团队占比60%'
    },
    {
      icon: <FiTrendingUp />,
      title: '1200+项目实战经验',
      desc: '服务涵盖市政、房建、公路、水利等全领域，累计审核金额超500亿元，平均审减率18%'
    },
    {
      icon: <FiClock />,
      title: '高效交付保障',
      desc: '2小时响应，标准项目7个工作日交付，AI辅助下审核周期缩短60%，质量终身负责'
    },
    {
      icon: <RmbIcon size={32} />,
      title: '性价比优势',
      desc: '数智化降本增效，服务费用比传统模式降低30%，透明计费，无隐性收费，客户续约率92%'
    }
  ];

  return (
    <section className="core-advantages">
      <div className="container">
        <h2 className="section-title">核心优势</h2>
        <p className="section-subtitle">为什么选择识道造价</p>
        <div className="advantages-grid">
          {advantages.map((item, index) => (
            <div key={index} className="advantage-card card">
              <div className="advantage-icon">{item.icon}</div>
              <h3>{item.title}</h3>
              <p>{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CoreAdvantages;

